export enum LayoutOptions {
  UNSPECIFIED = 0,
  LIST = 1,
  COLUMN = 2,
  COMPACT = 3,
}
